import React from 'react';
import { ArrowContainer, Popover } from 'react-tiny-popover';
import { Drawer } from 'components/ui';
import useResponsive from 'utils/hooks/useResponsive';

const DEFAULT_DESKTOP_CONTAINER_CLASS =
    'w-80 p-4 bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-xl';

const resolveMobileHeight = (override) => {
    if (typeof override === 'number') return override;
    if (typeof window === 'undefined') return 600;
    return Math.min(Math.round(window.innerHeight * 0.85), 720);
};

const ResponsiveInspirationPopover = ({
    isOpen,
    onClose,
    positions = ['right', 'center'],
    padding = 10,
    arrowSize = 6,
    containerStyle,
    title,
    desktopContainerClassName = DEFAULT_DESKTOP_CONTAINER_CLASS,
    mobileBodyClass = 'p-4 overflow-y-auto',
    mobileHeight,
    content,
    children,
}) => {
    const { smaller } = useResponsive();
    const isMobile = smaller.md;

    if (isMobile) {
        return (
            <>
                {children}
                <Drawer
                    isOpen={isOpen}
                    onClose={onClose}
                    placement="bottom"
                    height={resolveMobileHeight(mobileHeight)}
                    title={title}
                    closable
                    bodyClass={mobileBodyClass}
                >
                    {content}
                </Drawer>
            </>
        );
    }

    return (
        <Popover
            isOpen={isOpen}
            positions={positions}
            padding={padding}
            onClickOutside={onClose}
            containerStyle={containerStyle}
            content={({ position, childRect, popoverRect }) => (
                <ArrowContainer
                    position={position}
                    childRect={childRect}
                    popoverRect={popoverRect}
                    arrowColor="white"
                    arrowSize={arrowSize}
                    className="popover-arrow-container"
                    arrowClassName="popover-arrow"
                >
                    <div className={desktopContainerClassName}>{content}</div>
                </ArrowContainer>
            )}
        >
            {children}
        </Popover>
    );
};

export default ResponsiveInspirationPopover;
